/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import {
  Container,
  Switch,
  Typography,
} from "@mui/material";
import { patchPortfolioPreInstall } from "../../Services/redux/Application-details/ApplicationDetailsActions";
import "./ApplicationDetailsRollout.css";
import PropTypes from "prop-types";
import { getConfig } from "../../config";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 32,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 18,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(15.5px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#1890ff",
        ...theme.applyStyles("dark", {
          backgroundColor: "#177ddc",
        }),
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: "rgba(0,0,0,.25)",
    boxSizing: "border-box",
    ...theme.applyStyles("dark", {
      backgroundColor: "rgba(255,255,255,.35)",
    }),
  },
}));

function ApplicationDetailsRollout({
  postCallTheNewSubmission,
  postCallTheNewSubmissionGlobalAdmin,
}) {
  const dispatch = useDispatch();
  const [autoPublish, setAutoPublish] = useState(false);
  const [vehicleInstall, setVehicleInstall] = useState(false);
  const [preInstalled, setPreInstalled] = useState(false);
  const [garageMode, setGarageMode] = useState(false);
  const [majorVersion, setMajorVersion] = useState(false);
  const [hidden, setHidden] = useState(false);
  const submissionData = useSelector(
    (state) => state.submissionDetails.submissionDetails
  );
  const readOnly_GlobalAdmin =
    sessionStorage.getItem("readonly_GlobalAdmin") === "true";
  useEffect(() => {
    if (submissionData && Object.keys(submissionData).length > 0) {
      setPreInstalled(submissionData?.portfolioContentModes);
      setAutoPublish(submissionData?.autoPublish);
      setGarageMode(submissionData?.garageModeActive);
      setMajorVersion(submissionData?.isMajorVersion);
      setHidden(submissionData?.hidden);

      if (
        getConfig().REACT_APP_PORTAL === "seller" ||
        getConfig().REACT_APP_PORTAL === "domain-approver" ||
        getConfig().REACT_APP_PORTAL === "global-admin"
      ) {
        if (submissionData?.vehicleInstallationActive) {
          setVehicleInstall(submissionData?.vehicleInstallationActive);
        }
      }

      if (
        getConfig().REACT_APP_PORTAL === "oem-admin" &&
        submissionData.contentModes &&
        Object.keys(submissionData.contentModes).length > 0
      ) {
        setVehicleInstall(true);
        setGarageMode(true);
      }
    }
  }, [submissionData]);

  const changeAutoPublish = ($event, index) => {
    switch (index) {
      case 1:
        {
          let newSubmissionData = {
            ...submissionData,
            vehicleInstallationActive: $event.target.checked,
          };
          setVehicleInstall($event.target.checked);
          delete newSubmissionData["legalDocuments"];
          postCallTheNewSubmission(newSubmissionData);
        }
        break;
      case 2:
        if (getConfig().REACT_APP_PORTAL === "global-admin") {
          let payload = { garageModeActive: $event.target.checked };
          setGarageMode($event.target.checked);

          postCallTheNewSubmissionGlobalAdmin(payload);
        } else {
          let newSubmissionData = {
            ...submissionData,
            garageModeActive: $event.target.checked,
          };
          setGarageMode($event.target.checked);
          delete newSubmissionData["legalDocuments"];
          postCallTheNewSubmission(newSubmissionData);
        }
        break;
      case 3:
        {
          let newSubmissionData = {
            ...submissionData,
            isMajorVersion: $event.target.checked,
          };
          setMajorVersion($event.target.checked);
          delete newSubmissionData["legalDocuments"];
          postCallTheNewSubmission(newSubmissionData);
        }
        break;
      case 4:
        {
          let newSubmissionData = {
            ...submissionData,
            autoPublish: $event.target.checked,
          };
          setAutoPublish($event.target.checked);
          delete newSubmissionData["legalDocuments"];
          postCallTheNewSubmission(newSubmissionData);
        }
        break;
      case 5:
        {
          let newSubmissionData = {
            ...submissionData,
            hidden: $event.target.checked,
          };
          setAutoPublish($event.target.checked);
          delete newSubmissionData["legalDocuments"];
          postCallTheNewSubmission(newSubmissionData);
        }
        break;
      case 8:
      {
        setPreInstalled($event.target.checked);
        const formData = new FormData();
        formData.append("tags", JSON.stringify(submissionData.tags));
        formData.append("reasonForCountryExclusion", undefined);
        formData.append(
          "portfolioContentModes",
          $event.target.checked ? "PRE_INSTALL" : []
        );
        dispatch(
          patchPortfolioPreInstall(
            sessionStorage.getItem("portfolioId"),
            sessionStorage.getItem("contentId"),
            formData
          )
        );
      }
        break;
      

      default:
        break;
    }
  };

  const checkDomain = () => {
    return (
      sessionStorage.getItem("domain") !== "Audi" &&
      sessionStorage.getItem("domain") !== "Porsche" &&
      sessionStorage.getItem("domain") !== "VWGroup" &&
      sessionStorage.getItem("domain") !== "Asterix"
    );
  };
  return (
    <Container maxWidth="lg" style={{ marginBottom: "16px" }}>
      <div>
        <div>
          <section
            id="rollOutSettings"
            className="rollout"
            style={
              submissionData &&
              Object.keys(submissionData).length > 0 &&
              submissionData.status === "DRAFT"
                ? { marginBottom: "20px !important", width: "85%" }
                : { marginBottom: "20px !important" }
            }
          >
            <Typography
              sx={{
                "font-weight": "bold !important",
                "font-size": "20px !important",

                color: "rgba(18, 20, 21, 1) !important",
                "margin-right": "auto !important",
              }}
              className="uploadSignedApkText"
            >
              Rollout Settings
            </Typography>
            <div className="rollout-wrapper" style={{ marginTop: "15px" }}>
              {getConfig().REACT_APP_PORTAL === "oem-admin" &&
                sessionStorage.getItem("idpLogin") !== "true" && (
                  <div className="vehicle-install">
                    <div className="wrapper-diver ">
                      <p className="auto-text">Pre-Installed</p>
                      <div style={{ marginRight: "15px" }}>
                        <AntSwitch
                          disabled={
                            sessionStorage.getItem("readonly_OemAdmin") ===
                            "true"
                          }
                          checked={preInstalled}
                          onChange={($event) => changeAutoPublish($event, 8)}
                        />
                      </div>
                    </div>
                    <p className="rollout-overview">
                      Application will be auto-installed into all vehicles
                      targeted in the listings vehicle eligibility on next
                      ignition during update check.
                    </p>
                  </div>
                )}
              {((sessionStorage.getItem("isOemSeller") && checkDomain()) ||
                (getConfig().REACT_APP_PORTAL === "oem-admin" &&
                  sessionStorage.getItem("idpLogin") !== "true") ||
                (getConfig().REACT_APP_PORTAL === "global-admin" &&
                  sessionStorage.getItem("idpLogin") !== "true")) && (
                <div className="vehicle-install">
                  <div className="wrapper-diver ">
                    <p className="auto-text">Vehicle install</p>

                    <div style={{ marginRight: "15px" }}>
                      <AntSwitch
                        checked={vehicleInstall}
                        onChange={($event) => changeAutoPublish($event, 1)}
                        disabled={submissionData.status !== "DRAFT"}
                      />
                    </div>
                  </div>
                  <p className="rollout-overview">
                    Vehicle Install apps are only installable by the vehicle
                    owner and then available for all local profiles in the
                    vehicle. Typically, apps for vehicle functions from the OEM
                    should be marked as "Vehicle Install"
                  </p>
                </div>
              )}
              {(sessionStorage.getItem("isOemSeller") ||
                getConfig().REACT_APP_PORTAL === "global-admin" ||
                sessionStorage.getItem("idpLogin") === "true") && (
                <div className="vehicle-install">
                  <div className="wrapper-diver">
                    <p className="auto-text">Garage mode</p>
                    <div style={{ marginRight: "15px" }}>
                      <AntSwitch
                        checked={garageMode}
                        onChange={($event) => changeAutoPublish($event, 2)}
                        disabled={
                          getConfig().REACT_APP_PORTAL === "global-admin"
                            ? (submissionData.status !==
                                "APPROVED_FOR_PRODUCTION" &&
                                submissionData.status !== "PUBLISHED") ||
                              readOnly_GlobalAdmin
                            : submissionData.status !== "DRAFT"
                        }
                      />
                    </div>
                  </div>
                  <p className="rollout-overview">
                    Garage mode install means that the system will download at
                    the update check but only schedule the install if auto
                    install user preference is enabled
                  </p>
                </div>
              )}
              {((sessionStorage.getItem("idpLogin") === "true" &&
                submissionData.status === "DRAFT") ||
                (getConfig().REACT_APP_PORTAL === "global-admin" &&
                  submissionData.status === "GENERATING_DELTA")) && (
                <div className="vehicle-install">
                  <div className="wrapper-diver">
                    <p className="auto-text">Hidden</p>
                    <div style={{ marginRight: "15px" }}>
                      <AntSwitch
                        checked={hidden}
                        onChange={($event) => changeAutoPublish($event, 5)}
                        disabled={submissionData.status !== "DRAFT"}
                      />
                    </div>
                  </div>
                  <p className="rollout-overview">
                    This version will not be visible in catalog.
                  </p>
                </div>
              )}

              {(sessionStorage.getItem("isOemSeller") ||
                sessionStorage.getItem("idpLogin") === "true") && (
                <div className="vehicle-install">
                  <div className="wrapper-diver ">
                    <p className="auto-text">Major version</p>
                    <div style={{ marginRight: "15px" }}>
                      <AntSwitch
                        checked={majorVersion}
                        onChange={($event) => changeAutoPublish($event, 3)}
                        disabled={submissionData.status !== "DRAFT"}
                      />
                    </div>
                  </div>
                  <p className="rollout-overview">
                    Toggle to identify whether this update will be tagged as a
                    major Version. Based on this you could show a
                    update-information-screen within your own Group App after
                    receiving "available Update from the App Store Client in the
                    vehicle.
                  </p>
                </div>
              )}
              {(getConfig().REACT_APP_PORTAL === "seller" ||
                getConfig().REACT_APP_PORTAL === "domain-approver" ||
                getConfig().REACT_APP_PORTAL === "global-admin") && (
                <div>
                      <div className="wrapper-diver">
                        <p className="auto-text">Auto Publish</p>
                        <div style={{ marginRight: "15px" }}>
                          <AntSwitch
                            checked={autoPublish}
                            onChange={($event) => changeAutoPublish($event, 4)}
                            disabled={submissionData.status !== "DRAFT"}
                          />
                        </div>
                      </div>

                      <p className="rollout-overview">
                        Toggle to identify whether this application will be auto
                        published after been approved.
                      </p>
                    </div>
                  )}
            </div>
          </section>
        </div>
      </div>
    </Container>
  );
}

ApplicationDetailsRollout.propTypes = {
  postCallTheNewSubmission: PropTypes.func.isRequired,
  postCallTheNewSubmissionGlobalAdmin: PropTypes.func.isRequired,
};

export default ApplicationDetailsRollout;
